import React from 'react';
import WatchReview from '../watchReview'


function BehindTheMask(props) {

        return (
            <WatchReview 
                tube="https://www.youtube.com/embed/_YZgH_7oJ2c" 
                blerb="Welcome to Brothers Sip and Talk Shit, where we discuss all things horror and foreign...films. Over our next drink, we discuss 'Behind the Mask: The Rise of Leslie Vernon'."
            />
        )
    }   

export default BehindTheMask;